// this is autogenerated file, see version-update.js
export const VERSION = '0.1.1';
